import { Layout, Flex } from 'antd';
import Title from 'antd/es/typography/Title';
import MasterMenu from './_components/master-menu';
import { useState } from 'react';
import FarmerPage from '../master/farmer';
import LandPage from '../master/land';
import FarmPage from '../master/farm';
import NewsPage from '../master/news';
import CommunityPage from '../master/community';
import PricePage from '../master/price';
import MerchantPage from '../master/merchant';
import UploadImagesPage from '../master/images';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import CropPage from '../master/crop';

// import FarmerPage from '../master/farmer';

const { Sider, Content, Header } = Layout;

const MasterPage: React.FC = () => {
  const [key, setKey] = useState('farmer');
  const [collapsed, setCollapsed] = useState(true);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <Layout style={{ height: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={200}
        theme="light"
        style={{ background: 'transparent' }}
      >
        <div
          onClick={toggleCollapsed}
          style={{
            padding: 16,
            color: 'black',
            textAlign: 'center',
            fontSize: 15,
          }}
        >
          Menu {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
        <MasterMenu onchange={e => setKey(e as string)} />
      </Sider>
      <Layout>
        <Header
          style={{
            background: 'transparent',
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 16,
          }}
        >
          <Title level={2} className="text-center">
            OTOD-Durian SERVICES (1.2.0)
          </Title>
        </Header>
        <Content style={{ margin: '10px' }}>
          {key === 'farmer' && <FarmerPage />}
          {key === 'land' && <LandPage />}
          {key === 'crop' && <CropPage />}
          {key === 'farm' && <FarmPage />}
          {key === 'images' && <UploadImagesPage />}
          {key === 'news' && <NewsPage />}
          {key === 'community' && <CommunityPage />}
          {key === 'price' && <PricePage />}
          {key === 'merchant' && <MerchantPage />}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MasterPage;
